import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-badge',
  templateUrl: './info-badge.component.html',
  styleUrl: './info-badge.component.scss',
})
export class InfoBadgeComponent {
  @Input() message: string = 'missing.message';
  @Input() type: 'info' | 'warning' | 'error' | 'success' = 'info';

  get icon(): string {
    switch (this.type) {
      case 'info':
        return 'info-outline';
      case 'warning':
        return 'alert-triangle-outline';
      case 'error':
        return 'close-circle-outline';
      case 'success':
        return 'checkmark-circle-2-outline';
      default:
        return 'info-outline';
    }
  }
}
